module.exports = __webpack_public_path__ + "img/paid.d2726889.svg";